export const questions: Array<[string, string]> = [
  [
    'Who is it for?',
    'HVAC and refrigeration technicians, installers, maintenance and facilities technicians, engineers and students who want to understand and master heating, cooling and refrigeration systems.',
  ],
  [
    'Content depth?',
    'From fundamentals to advanced field practice, organized in 6 progressive volumes with visual explanations, diagrams and technical takeaways.',
  ],
  [
    'International?',
    'Yes. The content uses international concepts and both metric and imperial units, and always refers to manufacturer data and local regulations.',
  ],
  [
    'Format?',
    'Downloadable PDF volumes you can read on your phone, tablet or computer, with instant access after purchase.',
  ],
  ['Currency?', 'USD. Auto-converts to your local currency.'],
  ['Not satisfied?', '7-day refund. 100% money back.'],
];
